/*==================================================
=                 BMI DEWASA
==================================================*/

function calculateAdultBMI(heightCm, weightKg) {

    const heightMeters =
        heightCm / 100;

    const bmi =
        weightKg /
        (heightMeters * heightMeters);

    const result =
        classifyAdultBMI(bmi);

    const minimumWeight =
        (
            18.5 *
            heightMeters *
            heightMeters
        ).toFixed(1);

    const maximumWeight =
        (
            24.9 *
            heightMeters *
            heightMeters
        ).toFixed(1);

    return {
        bmi: bmi,
        category: result.category,
        advice: result.advice,
        healthyRange:
            `${minimumWeight} kg - ${maximumWeight} kg`
    };

}

function updateAdultResult(result) {

    bmiValue.textContent =
        result.bmi.toFixed(1);

    bmiCategory.textContent =
        result.category;

    advice.textContent =
        result.advice;

    healthyRange.textContent =
        result.healthyRange;

    bmiCategory.className =
        "bmi-category";

    switch (result.category) {

        case "Berat Badan Ideal":

            bmiCategory.classList.add(
                "healthy"
            );

            break;

        case "Kelebihan Berat Badan":

            bmiCategory.classList.add(
                "overweight"
            );

            break;

        case "Obesitas":

            bmiCategory.classList.add(
                "obese"
            );

            break;

        default:

            bmiCategory.classList.add(
                "underweight"
            );

    }

    let percent =
        (result.bmi / 40) * 100;

    percent =
        clamp(
            percent,
            2,
            98
        );

    pointer.style.left =
        `${percent}%`;

}